import { render } from "./HoursForm.vue?vue&type=template&id=04df3bd7&scoped=true"
import script from "./HoursForm.vue?vue&type=script&lang=js"
export * from "./HoursForm.vue?vue&type=script&lang=js"

import "./HoursForm.vue?vue&type=style&index=0&id=04df3bd7&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04df3bd7"]])

export default __exports__